module.exports = __webpack_public_path__ + "static/media/hall-banner.53471e81.png";